import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertService } from '../../core/services/alert.service';

@Component({
    selector: 'app-ui-alert-host',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="fixed top-4 right-4 z-[80] flex flex-col gap-2 w-[min(92vw,22rem)]">
      <div
        *ngFor="let item of alerts.items()"
        class="rounded-2xl px-4 py-3 shadow-lg text-sm font-semibold flex items-start gap-3"
        [class.bg-emerald-600]="item.kind === 'ok'"
        [class.text-white]="item.kind === 'ok' || item.kind === 'error'"
        [class.bg-rose-500]="item.kind === 'error'"
        [class.bg-white]="item.kind === 'info'"
        [class.text-gray-800]="item.kind === 'info'"
        [class.border]="item.kind === 'info'"
        [class.border-rose-100]="item.kind === 'info'">
        <span class="flex-1 leading-snug">{{ item.text }}</span>
        <button type="button" (click)="alerts.dismiss(item.id)" class="opacity-80 hover:opacity-100">×</button>
      </div>
    </div>
    `
})
export class UiAlertHostComponent {
    alerts = inject(AlertService);
}
